package com.vamvisions.main.portfolio.presentation.common

/** The first professional job started in April 2018. */
private const val START_YEAR = 2018
private const val START_MONTH = 4

/** Full years of experience on [nowYear]-[nowMonth] (month 1-12). A year counts as full from the first day of April. */
fun yearsOfExperience(nowYear: Int, nowMonth: Int): Int =
    nowYear - START_YEAR - if (nowMonth < START_MONTH) 1 else 0
